import { useMemo } from 'react';
import { UsePortfolioChartDataParams } from 'src/components/PortfolioPage/PortfolioTradeSubPage/types';
import {
	buildIntervalPnlBaseData,
	buildIntervalPnlLiveData,
} from 'src/components/PortfolioPage/PortfolioTradeSubPage/utils/buildIntervalPnlChartData';
import { PortfolioPeriod } from 'src/components/PortfolioPage/types';

interface Params extends UsePortfolioChartDataParams {
	period: PortfolioPeriod;
}

export default function usePortfolioIntervalPnlChartData({
	enabled,
	period,
	snapshots,
	metrics,
	currentCumulativeFunding,
	currentUnrealizedPnl,
	includeFeesAndFunding,
	realizedPnlOnly,
}: Params) {
	const intervalBase = useMemo(() => {
		return buildIntervalPnlBaseData({
			enabled,
			snapshots,
			includeFeesAndFunding,
			realizedPnlOnly,
		});
	}, [enabled, snapshots, includeFeesAndFunding, realizedPnlOnly]);

	const intervalLive = useMemo(() => {
		return buildIntervalPnlLiveData({
			enabled,
			period,
			metrics,
			currentCumulativeFunding,
			currentUnrealizedPnl,
			includeFeesAndFunding,
			realizedPnlOnly,
			latestSnapshotTotalPnl: intervalBase.latestSnapshotTotalPnl,
			latestSnapshotFeesAndFunding: intervalBase.latestSnapshotFeesAndFunding,
		});
	}, [
		enabled,
		period,
		metrics,
		currentCumulativeFunding,
		currentUnrealizedPnl,
		includeFeesAndFunding,
		realizedPnlOnly,
		intervalBase.latestSnapshotTotalPnl,
		intervalBase.latestSnapshotFeesAndFunding,
	]);

	return useMemo(() => {
		if (!intervalBase.series.length) {
			return intervalBase.series;
		}

		return [...intervalBase.series, intervalLive];
	}, [intervalBase.series, intervalLive]);
}
